import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LoaderService {

  constructor() { }

  private readonly loadingSubject: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  public loading$ = this.loadingSubject.asObservable();

  private readonly creditApplicationLoadingSubject: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(true);
  public creditApplicationLoading$ = this.creditApplicationLoadingSubject.asObservable();

  private readonly overlaySubject: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  public overlayState$ = this.overlaySubject.asObservable();

  /**
   * setLoadingState() - Method to set the loading state for the application
   * @param loading - boolean value to set the loading state
   */
  setLoadingState(loading: boolean) {
    setTimeout(() => {
      this.loadingSubject.next(loading);
    });
  }

  /**
   * setOverlayState() - Method to set the overlayState for control the visibility of a visual overlay means blocks the page's content and displays a loading spinner
   * @param overlayState - boolean value to set the overlay state
   */
  setOverlayState(overlayState: boolean): void{
    this.overlaySubject.next(overlayState);
  }

  /**
   * setCreditApplicationLoadingState() - Method to set the loading state for credit application in dashboard of studio portal
   * @param loading - boolean value to set the loading state
   */
  setCreditApplicationLoadingState(loading: boolean): void{
    this.creditApplicationLoadingSubject.next(loading);
  }
  
}
